import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import styled from 'styled-components';
import {useParams} from 'react-router';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import Panel from './Panel';
import Title from './Title';
import {
  Content,
  useUpdateContentWebsiteMutation,
  ContentWebsiteAttributes,
} from 'api';
import Form from './Form';

interface Props {
  content: Content;
}

export default ({content}: Props) => {
  const {id} = useParams<{id: string}>();
  const location = useLocation();
  const [updateWebsite] = useUpdateContentWebsiteMutation();

  const _content = React.useMemo(() => content, []);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    initialValues: {
      url: _content?.website?.url || '',
    },
    validationSchema: Yup.object().shape({
      url: Yup.string().url('不正なURLです').required('必須項目です'),
    }),
    onSubmit: (values: ContentWebsiteAttributes) =>
      updateWebsite({variables: {id, attributes: values}}),
  });

  return (
    <Container>
      <Title content={content} formik={formik} />
      <Main>
        <Menu>
          <MenuItem active={true}>
            <Link to={`/garage/contents/${id}/website${location.search}`}>
              設定
            </Link>
          </MenuItem>
        </Menu>
        <Content>
          <Form formik={formik} />
          <Panel />
        </Content>
      </Main>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const Main = styled.div`
  background: #fff;
  margin-top: 1.5rem;
  border-radius: 4px;
`;

const Menu = styled.div`
  display: flex;
  justify-content: center;
  height: 60px;
  border-bottom: solid 1px var(--border-color);
`;

const MenuItem = styled.div<{active?: boolean}>`
  height: 60px;
  display: flex;
  align-items: center;
  border-bottom: solid 3px;
  border-color: ${({active}) => (active ? 'var(--gray-700)' : 'transparent')};

  a {
    font-size: 14px;
    font-weight: ${({active}) => (active ? 700 : 400)};
    margin: 0 1rem;
    color: var(--text-color-1);
  }
`;

const Content = styled.div`
  display: flex;
  min-height: 480px;
`;
